import React from 'react'
import CustomSelect from "../Select/CustomSelect";
import { buildFilters, buildFinderFilters } from "../Filters/Utils";
import { connect } from "react-redux";
import {
  selectFilter,
  updateResults,
  setFilterMode,
  setActiveMode,
  /* redirectToProductFinder, */
  resetOnFilter,
  FilterModes, deletePath
} from "../../store/actions";


class FinderModeComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
    this.selectRefs = {};
    this.selectRefs.group = React.createRef();
    this.selectRefs.category = React.createRef();
    this.selectRefs.lineup = React.createRef();
    this.selectRefs.series = React.createRef();
  }

  resetAll = () => {
    this.selectRefs.group.current.resetValue();
    this.selectRefs.category.current.resetValue();
    this.selectRefs.lineup.current.resetValue();
    this.selectRefs.series.current.resetValue();
  };

  resetError = () => {
    if (this.state.error) {
      this.setState(state => ({ error: false }));
    }
  }

  selectFilter = (key, value) => {
    this.props.deletePath(key);
    this.props.selectFilter(key, value);
    if (this.state.error) {
      this.setState(state => ({ error: false }));
    }
    // No results. Results are updated when user clicks submit.
    const withResults = false;
    this.props.resetOnFilter();
    this.props.updateResults(withResults);
  };

  getResults = () => {
    this.props.setFilterMode(FilterModes.FILTER_MODE, false);
    const groupSelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'group') ? this.props.selections.group : false;
    const categorySelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'category') ? this.props.selections.category : false;
    const lineupSelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'lineup') ? this.props.selections.lineup : false;
    if (!groupSelection && !categorySelection && !lineupSelection) {
      this.setState(state => ({ error: true }));
      return;
    }
    else if (this.state.error) {
      this.setState(state => ({ error: false }));
    }

    this.props.updateResults(true);
  };

  resetFilters = () => {
    this.props.setFilterMode(FilterModes.FILTER_MODE, true);
    this.resetAll();
    this.props.updateResults(false);
  };

  switchToSearch = () => {
    this.props.setFilterMode(FilterModes.SEARCH_MODE, true);
  };

  onFocus = (e) => {
    this.props.setActiveMode(FilterModes.FILTER_MODE);
  };

  render() {
    let className = 'finder-mode product-finder-form';
    let disabled;
    if (this.props.activeMode === FilterModes.SEARCH_MODE) {
      className += ' inactive';
      disabled = true;
    }

    if (this.props.isFetching) {
      disabled = true;
    }
    const { group, category, lineup, series } = buildFilters(this.props.finderFilters);
    const groupSelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'group');
    const categorySelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'category');
    const lineupSelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'lineup');
    const seriesSelection = Object.prototype.hasOwnProperty.call(this.props.selections, 'series');
    const { error } = this.state;
    return (
      <form onFocus={this.onFocus} className={className}>
        <div className="form--inline" onFocus={this.onFocus}>
          {!this.props.redirectMode && (<h2 className="form__title block-title">{this.props.strings['STRING:TITLE']}</h2>)}
          <CustomSelect showError={error} isDisabled={this.props.isFetching || (group.length === 0)} isClearable={true} selectedValue={groupSelection ? this.props.selections.group : null} ref={this.selectRefs.group} onSelect={this.selectFilter} selectCustomName="group" selectCustomLabel={this.props.strings['STRING:GROUP_LABEL']} selectCustomOptions={group} withoutAutoSelect={!disabled} dispatchAction={this.props.selectFilter}/>
          <CustomSelect showError={error} isDisabled={this.props.isFetching || (category.length === 0)} isClearable={true} selectedValue={categorySelection ? this.props.selections.category : null} ref={this.selectRefs.category} onSelect={this.selectFilter} selectCustomName="category" selectCustomLabel={this.props.strings['STRING:CATEGORY_LABEL']} selectCustomOptions={category} withoutAutoSelect={!disabled} dispatchAction={this.props.selectFilter}/>
          <CustomSelect showError={error} isDisabled={this.props.isFetching || (lineup.length === 0)} isClearable={true} selectedValue={lineupSelection ? this.props.selections.lineup : null} ref={this.selectRefs.lineup} onSelect={this.selectFilter} selectCustomName="lineup" selectCustomLabel={this.props.strings['STRING:LINE_UP_LABEL']} selectCustomOptions={lineup} withoutAutoSelect={!disabled} />
          <CustomSelect isDisabled={this.props.isFetching || (series.length === 0)} isClearable={true} selectedValue={seriesSelection ? this.props.selections.series : null} ref={this.selectRefs.series} closeMenuOnSelect={false} onSelect={this.selectFilter} selectCustomName="series" selectCustomLabel={this.props.strings['STRING:SERIES_LABEL']} selectCustomOptions={series} isMulti={true} withoutAutoSelect={!disabled} />
          <div className="form__actions ">
            {((!!this.props.count && this.props.withResults) && <button disabled={disabled || this.props.isFetching} className="button submit" onClick={this.getResults} name="submit" type="button">{this.props.strings['STRING:SEE_RESULTS'].replace('!count', this.props.count)}</button>)}
            {((!this.props.count || !this.props.withResults) && <button disabled={disabled || this.props.isFetching} className="button submit" onClick={this.getResults} name="submit" type="button">{this.props.strings['STRING:FIND_YOUR_PRODUCT']}</button>)}
            <div className="form__actions__secondary">
              <button disabled={disabled} className="reset" onClick={this.resetFilters} name="reset-filters" type="button">{this.props.strings['STRING:RESET_FILTERS']}</button>
            </div>
          </div>
          {error && (<div className="error__message">{this.props.strings['STRING:ERROR_FINDER']}</div>)}
        </div>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  let finderFilters = buildFinderFilters(state.results.aggregations);
  let selections = state.parameters.filters;
  const count = state.results.count;
  const withResults = state.results.result.length > 0;
  const mode = state.parameters.mode;
  const activeMode = state.parameters.activeMode;
  const isFetching = state.results.isFetching;
  if (Object.prototype.hasOwnProperty.call(state.results.aggregations, 'path')) {
    
    // path values from response used to override query attribute values (group, cat, ...) from the url
    const forcedPath = state.results.aggregations.path;
    for (let [key, value] of Object.entries(forcedPath)) {
      if (value && !Object.prototype.hasOwnProperty.call(selections, key)) {
        //prevent category from being set when group was deleted
        if (selections['group'] === null || selections['group'] === 'null') {
          continue;
        }
        // TODO: direct state manipulation!!!
        selections[key] = value[0]?.key;
      }
    }
  }
  return { finderFilters, count, selections, mode, activeMode, isFetching, withResults }
};

export default connect(
  mapStateToProps,
  { selectFilter, updateResults, setFilterMode, setActiveMode, /* redirectToProductFinder ,*/ resetOnFilter, deletePath },
  null,
  { forwardRef: true }
)(FinderModeComponent)

